// extracted by mini-css-extract-plugin
export default {"sparkle":"hMjK1J","eclipseAiHatSparkle":"RWTkaa","text":"OdrdPa","eclipseAiHatShimmer":"ZkwzmE","subtitle":"oDt2Yy","settled":"JXXULB"};